import {getUserData} from "../modulesUtils";
import {photoSwipe} from "../photoswipe/photoswipe";

/**
 * Funcionalidad del módulo de noticias lateral de La Bolsa Hoy.
 * Este módulo tiene un gemelo que carga sin ajax (este código no aplica)
 */
export function laBolsaHoyModule() {
    return $(function () {
        var $container = $('section.md-markets');
        var $ul = $('<ol></ol>');

        $.ajax({
            url: $container.data('url'),
            dataType: 'json',
            error: function () {
                $('.md-carpatos-full').remove();
            },
            success: function (data) {
                if (data) {
                    var currentDate = new Date().toDateString();
                    for (var i = 0; i < data.length; i++) {
                        var label;
                        if (data[i].premiumLabel) {
                            label = '<span style="font-size: 1rem; font-weight: 500; background: #ce1d1a; color: white; padding: 6px 4px;">PREMIUM</span>';
                        } else {
                            var fecha;
                            fecha = new Date(data[i].date);
                            if (!(fecha instanceof Date && !isNaN(fecha))) {
                                var pattern = /(\d{4})-(\d{1,2})-(\d{1,2}) (\d{1,2}):(\d{1,2})/;
                                var components = pattern.exec(data[i].date);
                                fecha = new Date(components[1], (components[2] - 1), components[3], components[4], components[5]);
                            }

                            var fechaStr = '';
                            if (fecha.toDateString() === currentDate) {
                                fechaStr = fecha.getHours() + ':' + ('0' + fecha.getMinutes()).slice(-2);
                            } else {
                                fechaStr = ('0' + fecha.getDate()).slice(-2) + '/' + ('0' + (fecha.getMonth() + 1)).slice(-2);//+'/'+ fecha.getFullYear();
                            }

                            label = '<time>' + fechaStr + '</time>';
                        }

                        $ul.append(
                            '<li><article>' +
                            '<div>' + label + '</div>' +
                            '<a class="lnk" href="' + data[i].url + '" data-gtmaside="market-today">' + data[i].title + '</a>' +
                            '</article></li>'
                        );
                    }
                    $container.append($ul);
                    $container.show();
                } else {
                    $container.remove();
                }

            }
        })
    });
}

/**
 * Funcionalidad que permite cargar noticias de la bolsa hoy relativas a un ticker.
 * Usado en la propia bolsa hoy y en las fichas de noticia, permite ofuscar las noticias
 * premium y solo cargarlas si el usuario es premium.
 */
export const laBolsaHoyTickerPremiumNews = async () => {

    let subscriptionUrl = null;
    let newsUrl = null;

    function userNotPremium(anonymous) {
        const notPremium = 'Este contenido únicamente es para suscriptores. Si deseas suscribirte pulsa <a href="' + subscriptionUrl + '" class=\"lnk\" title=\"Para ver este contenido debes suscribirte\">aquí</a> ';
        const notRegister = notPremium + 'o si ya eres usuarios premium, accede desde <a href="#suscriptionModal" class="lnk" title="Para ver este contenido debes ser suscriptor" data-lightbox="">accede con tu cuenta</a>';

        const message = anonymous ? notRegister : notPremium;
        $('.lbh-premium').html('<p>' + message + '</p>');
        photoSwipe();
    }

    function loadPremiumContent(elementsId) {
        const checkUrl = `${newsUrl}/${elementsId.join(',')}`;
        $.get(checkUrl, (data) => {
            let news;
            try {
                news = JSON.parse(data);
            } catch (e) {
                news = data;
            }

            if (!news || !news.hasOwnProperty('response')) {
                $('.lbh-premium').html('No se pudo cargar el contenido. Reinténtelo en unos minutos.');
            } else {
                news.response.map(function (item) {
                    $('.lbh-premium[data-newsid="' + item.news + '"]').html(item.text);
                })
            }
            photoSwipe();
        });
    }

    function checkUserPermission(user, elementsId) {
        let isPremium = user && user.hasOwnProperty('premium') && user.premium === true;
        isPremium = isPremium || user && user.hasOwnProperty('trial') && user.trail === true;

        if (user && user.login && isPremium) {
            return loadPremiumContent(elementsId);
        } else if (user && user.login) {
            return userNotPremium(false);
        } else {
            return userNotPremium(true);
        }
    }

    function checkPremiumContent(user) {
        const elements = $('.lbh-premium');
        if (!elements.length) {
            photoSwipe();
            return;
        }

        const urlHolder = $('.md-market-timeline');
        subscriptionUrl = urlHolder.data('suscriptionurl');
        newsUrl = urlHolder.data('newsurl');

        const newsId = [];
        elements.each(function () {
            newsId.push($(this).data('newsid'));
        });

        return checkUserPermission(user, newsId);
    }

    try {
        const userData = await getUserData();
        checkPremiumContent(userData);
    } catch (e) {
        checkPremiumContent(null);
    }
}
